var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"col-md-12 p-0"},[_c('div',{staticClass:"card"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }